<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('accessorCertificateRequest.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('accessorCertificateRequest.pageTitle'),
            href: '/admin/academic/accessor-certificate-requests',
          },
          {
            text: $t('accessorCertificateRequest.approve'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <ts-panel>
          <ts-panel-wrapper class="tw-space-y-2">
            <div class="row tw-space-y-1">
              <label class="required col-2 tw-py-2">{{
                $t("evaluationExamination.issueDate")
              }}</label>
              <div class="col-3">
                <a-date-picker
                  v-model="issue_date"
                  style="width: 100%"
                  placeholder="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  @change="onChangeIssueDate"
                />
                <div class="invalid-feedback" v-if="errors.has('issue_date')">
                  {{ errors.first("issue_date") }}
                </div>
              </div>
            </div>

            <h1 class="section-divider-underline">
              {{ $t("accessorCertificateRequest.candidate") }}
            </h1>
            <div class="col-12" v-if="approveDatas['candidates']">
              <label class="form-label col-form-label col-md-4">
                <span>Card Number : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].card_number }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Candidate : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].fname_en }}
                  {{ approveDatas["candidates"].lname_en }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Sex : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].sex }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Dob : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].dob }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Register Date : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].register_date }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Phone : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].phone }}</span
                >
              </label>
            </div>

            <h1 class="section-divider-underline tw-border-t-2 tw-pt-2">
              {{ $t("accessorCertificateRequest.levelSkill") }}
            </h1>
            <div class="col-12 tw-space-y-4">
              <div class="col-12">
                <label class="form-label col-form-label col-md-4">
                  <span>Course Name : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"].examination_event
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Skill Level : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"].level_skill_name
                    }}</span
                  >
                  <span> | Lv : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"].skill_level_order
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Certficate Type : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"].cert_type_name
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Available Year : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"].available_in_year
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Expire Date : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{ approveDatas["requestSkillLevel"].expire_date }}</span
                  >
                </label>
              </div>
              <div class="row tw-h-auto">
                <table class="tw-w-full">
                  <thead>
                    <tr class="tw-uppercase tw-bg-gray-200 tw-h-10">
                      <th class="tw-pl-2" style="width: 10%">
                        {{ $t("accessorCertificateRequest.subjectCode") }}
                      </th>
                      <th class="tw-pl-2" style="width: 30%">
                        {{ $t("accessorCertificateRequest.subject") }}
                      </th>
                      <th class="tw-pl-2" style="width: 10%">
                        {{ $t("accessorCertificateRequest.subjectType") }}
                      </th>
                      <th class="tw-text-center" style="width: 10%">
                        {{ $t("accessorCertificateRequest.isPass") }}
                      </th>
                      <th style="width: 20%">
                        {{ $t("accessorCertificateRequest.remark") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(subject, index) in approveDatas[
                        'requestSkillLevel'
                      ].evaluation_examinations"
                      :key="index"
                      class="tw-w-full tw-h-10"
                    >
                      <td class="tw-whitespace-no-wrap tw-pl-2">
                        {{ subject.subject_code }}
                      </td>
                      <td class="tw-whitespace-no-wrap tw-pl-2">
                        {{ subject.subject_name_en }}
                      </td>
                      <td class="tw-whitespace-no-wrap tw-pl-2">
                        {{ subject.subject_type_id == 1 ? "Basic" : "Core" }}
                      </td>
                      <td class="tw-text-center tw-items-center">
                        <span
                          v-if="subject.is_passed"
                          class="badge bg-primary mr-2 tw-capitalize"
                        >
                          Pass</span
                        >
                        <span v-else class="badge bg-danger mr-2 tw-capitalize">
                          Fail</span
                        >
                      </td>
                      <td class="tw-whitespace-no-wrap">
                        <input
                          disabled
                          v-model="subject.remarks"
                          placeholder="remarks"
                          style="min-width: 90px"
                          class="form-control"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <h1 class="section-divider-underline tw-border-t-2 tw-pt-2">
              {{ $t("accessorCertificateRequest.accessor") }}
            </h1>
            <div class="col-12 tw-space-y-4">
              <div class="col-12">
                <label class="form-label col-form-label col-md-4">
                  <span>Course Name : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{ approveDatas["accessorSkill"].examination_event }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Skill Level : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{ approveDatas["accessorSkill"].level_skill_name }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Certficate Type : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{ approveDatas["accessorSkill"].cert_type_name }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Available Year : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{ approveDatas["accessorSkill"].available_in_year }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Expire Date : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{ approveDatas["accessorSkill"].expire_date }}</span
                  >
                </label>
              </div>
              <div class="row tw-h-auto">
                <table class="tw-w-full">
                  <thead>
                    <tr class="tw-uppercase tw-bg-gray-200 tw-h-10">
                      <th class="tw-pl-2" style="width: 10%">
                        {{ $t("accessorCertificateRequest.subjectCode") }}
                      </th>
                      <th class="tw-pl-2" style="width: 30%">
                        {{ $t("accessorCertificateRequest.subject") }}
                      </th>
                      <th class="tw-pl-2" style="width: 10%">
                        {{ $t("accessorCertificateRequest.subjectType") }}
                      </th>
                      <th class="tw-text-center" style="width: 10%">
                        {{ $t("accessorCertificateRequest.isPass") }}
                      </th>
                      <th style="width: 20%">
                        {{ $t("accessorCertificateRequest.remark") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(subject, index) in approveDatas['accessorSkill']
                        .evaluation_examinations"
                      :key="index"
                      class="tw-w-full tw-h-10"
                    >
                      <td class="tw-whitespace-no-wrap tw-pl-2">
                        {{ subject.subject_code }}
                      </td>
                      <td class="tw-whitespace-no-wrap tw-pl-2">
                        {{ subject.subject_name_en }}
                      </td>
                      <td class="tw-whitespace-no-wrap tw-pl-2">
                        {{ subject.subject_type_id == 1 ? "Basic" : "Core" }}
                      </td>
                      <td class="tw-text-center tw-items-center">
                        <span
                          v-if="subject.is_passed"
                          class="badge bg-primary mr-2 tw-capitalize"
                        >
                          Pass</span
                        >
                        <span v-else class="badge bg-danger mr-2 tw-capitalize">
                          Fail</span
                        >
                      </td>
                      <td class="tw-whitespace-no-wrap">
                        <input
                          disabled
                          v-model="subject.remarks"
                          placeholder="remarks"
                          style="min-width: 90px"
                          class="form-control"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ts-panel-wrapper>
        </ts-panel>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'accessor-certificate-request' })"
        :disabled="waiting_new || waiting"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button
        color="danger"
        outline
        :waiting="waiting_new"
        :disabled="waiting_new || waiting"
        @click.prevent="onReject"
      >
        {{ $t("accessorCertificateRequest.reject") }}</ts-button
      >
      <ts-button
        color="primary"
        :waiting="waiting"
        :disabled="waiting_new || waiting"
        @click.prevent="onApprove"
      >
        {{ $t("accessorCertificateRequest.approve") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { mapActions, mapState } from "vuex";
import { Errors } from "form-backend-validation";
import moment from "moment";

export default {
  name: "accessorCertificateRequestCreate",
  components: {},
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      request_id: null,
      exam_register_id: null,
      issue_date: moment().format("DD-MM-YYYY"),
      errors: new Errors(),
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  computed: {
    ...mapState("academic/accessorCertificateRequest", [
      "edit_data",
      "approveDatas",
    ]),
  },
  methods: {
    ...mapActions("academic/accessorCertificateRequest", ["approve"]),
    async fetchFormViewModel({ candidate_id, request_skill_id }) {
      this.waiting = true;
      await this.approve({
        index: undefined,
        params: {
          candidate_id: candidate_id,
          request_skill_id: request_skill_id,
        },
      });
      this.exam_register_id =
        this.approveDatas["requestSkillLevel"].exam_register_id;
      this.waiting = false;
    },
    onChangeIssueDate(dateString) {
      this.issue_date = dateString;
    },
    async onApprove() {
      this.waiting = true;
      this.$store
        .dispatch("academic/accessorCertificateRequest/isReject", {
          id: this.request_id,
          data: {
            is_rejected: true,
            level_skill_id:
              this.approveDatas["requestSkillLevel"].level_skill_id,
            candidate_id: this.approveDatas["candidates"].candidate_id,
            level_skill_name:
              this.approveDatas["requestSkillLevel"].level_skill_name,
            issue_date: this.issue_date,
            exam_register_id: this.exam_register_id,
          },
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .finally(() => {
          this.waiting = false;
          this.$router.push({ name: "accessor-certificate-request" });
        });
    },
    async onReject() {
      this.waiting = true;
      this.$store
        .dispatch("academic/accessorCertificateRequest/isReject", {
          id: this.request_id,
          data: {
            is_rejected: false,
            level_skill_id:
              this.approveDatas["requestSkillLevel"].level_skill_id,
            candidate_id: this.approveDatas["candidates"].candidate_id,
            level_skill_name:
              this.approveDatas["requestSkillLevel"].level_skill_name,
            issue_date: this.issue_date,
            exam_register_id: this.exam_register_id,
          },
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .finally(() => {
          this.waiting = false;
          this.$router.push({ name: "accessor-certificate-request" });
        });
    },
    clearError() {
      this.errors = new Errors();
    },
    clearInput() {
      (this.model.course_skill_id = null), (this.model.is_evaluated = false);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.request_id = to.params.request_id;
      vm.fetchFormViewModel({
        candidate_id: to.params.candidate_id,
        request_skill_id: to.params.request_skill_id,
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
